import React from 'react';

import { useQuery } from '@tanstack/react-query';

import FormContainer from '../../components/AddOrEditPage/FormContainer';
import Layout from '../../containers/Layout';

import useContactUsForm from '../../forms/help/contactUs';
import ServicerService from '../../services/ServicerService';
import { useServicerStore } from '../../store';

export default function ContactUsPage() {
  const servicerId = useServicerStore((state) => state.servicerId);

  const { data: servicer } = useQuery({
    queryKey: ['servicer', servicerId],
    queryFn: () => ServicerService.getServicer(servicerId),
    enabled: !!servicerId,
  });

  const servicerAddressParts = servicer
    ? [
        servicer._contact.address_line_1,
        servicer._contact.address_line_2,
        servicer._contact.city,
        servicer._contact.state,
        servicer._contact.zip,
      ].filter(Boolean)
    : [];

  const servicerWithAddress = servicer
    ? {
        ...servicer,
        _contact: {
          ...servicer._contact,
          address: servicerAddressParts.join(', '),
        },
      }
    : null;

  const form = useContactUsForm(() => {}, servicerWithAddress);

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Contact us
                  </h1>
                </div>
              </div>
              <div className="p-7 pt-3 pb-2 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
                <FormContainer
                  form={form}
                  noSubmit
                  noBillComId
                  gridStyle="grid gap-5 md:grid-cols-1 xl:grid-cols-1"
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
